// apps/web/src/components/breach/BreachDetection.tsx
// Account + breach monitoring.

import { useState } from 'react';

interface BreachAlert {
  id: string;
  severity: 'LOW' | 'MEDIUM' | 'HIGH' | 'CRITICAL';
  summary: string;
  resolved: boolean;
}

const SEED: BreachAlert[] = [
  { id: '1', severity: 'MEDIUM', summary: 'New device signed in from a new location.', resolved: false },
  { id: '2', severity: 'LOW', summary: 'Authentication method updated.', resolved: true },
];

export function BreachDetection() {
  const [alerts] = useState<BreachAlert[]>(SEED);

  const badgeClass = (s: BreachAlert['severity']) =>
    s === 'CRITICAL' ? 'risk-critical' : s === 'HIGH' ? 'risk-high' : s === 'MEDIUM' ? 'risk-medium' : 'risk-low';

  return (
    <div className="breach-detection">
      <div className="header"><h2>Breach Detection</h2></div>
      <div className="manager-grid">
        {alerts.map((a) => (
          <div className="manager-card" key={a.id}>
            <h3>{a.summary}</h3>
            <p className={`risk-badge ${badgeClass(a.severity)}`}>{a.severity}</p>
            <p className="status-badge">{a.resolved ? 'Resolved' : 'Open'}</p>
            <div className="actions">
              <button className="btn btn-secondary">Investigate</button>
              {!a.resolved && <button className="btn btn-primary">Acknowledge</button>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}